import { render, staticRenderFns } from "./ProductSingleRelatedProducts.vue?vue&type=template&id=2788c28d&"
import script from "./ProductSingleRelatedProducts.vue?vue&type=script&lang=js&"
export * from "./ProductSingleRelatedProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports